import api, { formatErr } from "./api";

const loadScript = () => new Promise((resolve, reject) => {
  if (window.Razorpay) return resolve();
  const s = document.createElement("script");
  s.src = "https://checkout.razorpay.com/v1/checkout.js";
  s.onload = resolve;
  s.onerror = () => reject(new Error("Could not load Razorpay. Check your internet and try again."));
  document.body.appendChild(s);
});

// Opens Razorpay checkout; resolves with the fulfilment message, rejects with a user-facing error.
export async function payWithRazorpay(payload) {
  let order;
  try {
    await loadScript();
    order = (await api.post("/rzp/order", payload)).data;
  } catch (e) { throw new Error(e.message && !e.response ? e.message : formatErr(e)); }
  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: order.key_id,
      amount: order.amount,
      currency: order.currency,
      order_id: order.order_id,
      name: "HIFIREELS",
      description: order.title,
      image: "/logo192.png",
      prefill: order.prefill,
      theme: { color: "#FFD700" },
      handler: async (res) => {
        try { resolve((await api.post("/rzp/verify", res)).data.result); }
        catch (e) { reject(new Error(formatErr(e))); }
      },
      modal: { ondismiss: () => reject(new Error("Payment cancelled")) },
    });
    rzp.on("payment.failed", (r) => reject(new Error(r?.error?.description || "Payment failed")));
    rzp.open();
  });
}
